// extracted by mini-css-extract-plugin
export default {"bigModuleHead":"index_bigModuleHead_DVg9j","title":"index_title_YtEZi","more":"index_more_a067w","zggd":"index_zggd_pFEjt"};